import loadable from '@/utils/loadable';

export const LoginPage = loadable(() => import('@/pages/auth/LoginPage'));
export const SignupPage = loadable(() => import('@/pages/auth/SignupPage'));
export const HomePage = loadable(() => import('@/pages/Home'));
export const InplayPage = loadable(() => import('@/pages/Inplay'));
export const SportsPage = loadable(() => import('@/pages/Sports'));
export const MarketsPage = loadable(() => import('@/pages/Markets'));
export const MultiMarketPage = loadable(() => import('@/pages/MultiMarket'));
export const CasinoPage = loadable(() => import('@/pages/Casino'));
export const QTECHLobbyPage = loadable(() => import('@/pages/QTECHLobby'));
export const ProfilePage = loadable(() => import('@/pages/Profile'));
export const ProfitLoss = loadable(() => import('@/pages/ProfitLoss'));
export const AccountStatementPage = loadable(() => import('@/pages/AccountStatment'));
export const StackSetting = loadable(() => import('@/pages/StackSetting'));
export const CasinoPlaygroundPage = loadable(() => import('@/pages/CasinoPlayground'));
export const BetHistoryPage = loadable(() => import('@/pages/BetHistory'));
export const ActivityLogsPage = loadable(() => import('@/pages/ActivityLog'));
export const CasinoResultsPage = loadable(() => import('@/pages/CasinoResults'));
export const CasinoBetHistoryPage = loadable(() => import('@/pages/CasinoBetHistory'));
export const ChangePasswordPage = loadable(() => import('@/pages/ChangePassword'));
export const TermsConditionsPage = loadable(() => import('@/pages/TermsAndConditions'));
export const LiveCasinoBetsPage = loadable(() => import('@/pages/LiveCasinoBets'));
export const ReferralPage = loadable(() => import('@/pages/Referral'));
export const ProfitLossPage = loadable(() => import('@/pages/ProfitLoss'));

export const Dashboard = loadable(() => import('@/pages/Dashboard'));
